export default "__VITE_ASSET__CpUkBEKY__"